var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47.5,
    fill: "#66EAE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7703 68.0116L45.2303 67.6459C42.5277 65.755 40.0164 63.6045 37.7322 61.225C33.7187 57.0203 29.2188 50.7175 29.2188 43.2784C29.2188 34.1266 36.6466 25 47.5 25C58.3534 25 65.7812 34.1266 65.7812 43.2813C65.7812 50.7203 61.2812 57.0231 57.2678 61.2222C54.9836 63.6017 52.4723 65.7522 49.7697 67.6431C49.5409 67.8025 49.3609 67.9244 49.2297 68.0088C48.6587 68.3884 48.0766 68.7484 47.5 69.1141C46.9234 68.7484 46.3413 68.3884 45.7703 68.0116ZM47.5 48.9063C48.9918 48.9063 50.4226 48.3136 51.4775 47.2587C52.5324 46.2038 53.125 44.7731 53.125 43.2813C53.125 41.7894 52.5324 40.3587 51.4775 39.3038C50.4226 38.2489 48.9918 37.6563 47.5 37.6563C46.0082 37.6563 44.5774 38.2489 43.5225 39.3038C42.4676 40.3587 41.875 41.7894 41.875 43.2813C41.875 44.7731 42.4676 46.2038 43.5225 47.2587C44.5774 48.3136 46.0082 48.9063 47.5 48.9063Z",
    fill: "#00629D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationShare);
export default __webpack_public_path__ + "static/media/location-share.32dce4c52eb0fa115f99d7d2008752fa.svg";
export { ForwardRef as ReactComponent };